import { render, staticRenderFns } from "./PaymentDetailsScreen.vue?vue&type=template&id=d70f1218&"
import script from "./PaymentDetailsScreen.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d70f1218')) {
      api.createRecord('d70f1218', component.options)
    } else {
      api.reload('d70f1218', component.options)
    }
    module.hot.accept("./PaymentDetailsScreen.vue?vue&type=template&id=d70f1218&", function () {
      api.rerender('d70f1218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/dashboard/screens/PaymentDetailsScreen.vue"
export default component.exports